import { Box } from 'native-base'
import React from 'react'

const SeparatorLine = () => {
  return <Box m={10} alignSelf={'center'} width={'80%'} borderBottomWidth={1} borderBottomColor={'blue.800'} />
}

export default SeparatorLine
